<template>
  <div class="flex lg:flex-col lg:items-start">
    <div
      v-for="(item, index) in STEPS"
      :key="item.stepNumber"
      class="flex items-center lg:flex-col lg:items-start"
    >
      <div
        class="relative flex items-center"
      >
        <div
          class="flex h-9 min-w-[36px] flex-col items-center justify-center rounded-full transition-colors duration-300 lg:h-12 lg:min-w-[48px]"
          :class="item.stepNumber === store.activeStep || index + 1 < store.activeStep ? 'bg-blue text-white' : 'bg-blue-100 text-blue-800'"
        >
          <Icon v-if="index + 1 < store.activeStep" name="checked" color="white" />
          <span
            v-else
            class="text-base font-semibold transition-colors duration-1000 xl:text-xl"
            >{{ item.stepNumber }}</span
          >
        </div>
        <div
          class="absolute -bottom-5 left-1/2 -translate-x-1/2 translate-y-full text-center text-base text-blue-800 lg:static lg:ml-5 lg:transform-none xl:text-xl lg:whitespace-nowrap"
          :class="{ 'font-semibold' : item.stepNumber === store.activeStep }"
        >
          {{ item.title }}
        </div>
      </div>
      <div
        v-if="index + 1 < STEPS.length"
        class="relative my-6 h-[2px] w-auto min-w-[84px] bg-light-gray after:absolute after:left-0 after:top-0 after:z-1 after:h-[2px] after:w-0 after:bg-blue after:transition-all after:duration-1000 after:content-[''] lg:mx-6 lg:my-0 lg:h-auto lg:min-h-[48px] lg:w-[2px] lg:min-w-[auto] after:lg:h-0 after:lg:w-px"
        :class="{ 'after:w-full after:lg:h-full': index + 1 < store.activeStep }"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useInquiryStore } from '~/stores/InquiryStore'
const { t } = useI18n()

const STEPS = [
  {
    title: t('inquiryForm.stepOne.name'),
    stepNumber: 1
  },
  {
    title: t('inquiryForm.stepTwo.name'),
    stepNumber: 2
  },
  {
    title: t('inquiryForm.stepThree.name'),
    stepNumber: 3
  }
]

const store = useInquiryStore()
</script>
